export const agents = {
  seo: {
    title: 'Werde Bistroo Sales Agent: 40% wiederkehrende Provision',
    description: 'Verkaufe Next-Gen-Restaurantsoftware in NL, BE & DE. Verdiene 40% wiederkehrende Provision mit einer €1.500/Monat Anlaufgarantie.',
  },
  hero: {
    badge: 'Jetzt Agents in NL, BE & DE gesucht',
    title_1: 'Verkaufe Restauranttechnik, die sich selbst verkauft. Verdiene',
    title_em: '40% wiederkehrende Provision',
    title_2: 'solange deine Kunden bleiben.',
    subtitle: 'Bistroo ist die Next-Gen-E-Commerce-Suite für Quick-Service-Restaurants: Webshops, Websites, QR-Bestellen, Kioske und Kasse. Du bringst die Restaurants. Wir sorgen dafür, dass sie nie mehr gehen wollen. Und du wirst bezahlt, jeden Monat, den sie bleiben.',
    cta_primary: 'Agent werden',
    cta_secondary: 'Deal ansehen ↓',
    stats: [
      { value: '40%', label: 'wiederkehrende Provision' },
      { value: '€1.500/mo', label: 'Anlaufgarantie, 4 Monate' },
      { value: 'Wöchentlich', label: 'ausgezahlt während der Anlaufphase' },
      { value: '3', label: 'Länder zum Verkaufen' },
    ],
  },
  products: {
    kicker: 'Was du verkaufst',
    heading: 'Software, die Restaurantbesitzer wirklich lieben.',
    lead: 'Bistroo versorgt Quick-Service-Restaurants mit einer kompletten, Plug-and-Play-Bestellsuite: keine Langzeitverträge, monatlich kündbar, Einstiegspreis mit Premium-Gefühl. Das ergibt ein leichtes Ja an der Theke.',
    items: [
      { icon: '🛍️', title: 'Webshop & Website', text: 'Vollständig anpassbare Abhol- & Lieferwebshops plus eine restauranteigene Website. Eigener Kanal, eigene Kunden, eigene Daten.' },
      { icon: '📱', title: 'QR-Tischbestellung', text: 'Gäste scannen, bestellen und bezahlen vom Tisch. Weniger Laufen, mehr Umsatz pro Schicht.' },
      { icon: '🖥️', title: 'Kiosk & Kasse', text: 'Selbstbestellkioske und ein Kassenmodul speziell für Quick-Service. Eine Suite, ein Abonnement, verwaltet im intuitiven Bistroo Manager.' },
    ],
  },
  deal: {
    kicker: 'Der Deal',
    heading: 'Aufbau eines Einkommens, das wächst. Kein einmaliger Bonus.',
    lead: 'Die meisten Salesdeals zahlen einmal aus. Wir zahlen dir 40% des wiederkehrenden Umsatzes von jedem Restaurant, das du onboardest, jeden Monat, den sie bei Bistroo bleiben. Einmal onboarden, dauerhaft verdienen.',
    commission: {
      title: 'Wiederkehrende Provision',
      value: '40%',
      text: 'Auf den wiederkehrenden Umsatz jedes Geschäftskunden, den du onboardest, solange er ein aktiver Bistroo-Partner bleibt. Dein Portfolio wächst und dein monatliches Einkommen wächst mit.',
    },
    retainer: {
      pill: 'Anlaufgarantie',
      title: 'Deine ersten 4 Monate, risikofrei.',
      value: '€1.500/mo',
      text: 'Wiederkehrende Provision braucht Zeit zum Aufbauen, deshalb überbrücken wir das. Onboarde 8 neue Geschäftskunden in einem Monat und wir garantieren dir €1.500 in diesem Monat, wöchentlich ausgezahlt: Konvertiere 2 Geschäftskunden in einer Woche und du wirst diese Woche bezahlt.',
    },
  },
  ramp: {
    kicker: 'So funktioniert die Anlaufphase',
    heading: 'Von garantierter Vergütung zu selbsttragender Provision in 4 Monaten.',
    lead: 'Halte das Tempo von 8 onboardeten Geschäftskunden pro Monat und die Rechnung erledigt den Rest: Nach Monat 4 hältst du ein Portfolio von 32+ Restaurants, das mindestens €1.440 monatliche Provision generiert, und es wächst mit jedem neuen Kunden, den du hinzufügst.',
    table_headers: ['Monat', 'Ziel (neue Kunden)', 'Portfolio gesamt', 'Garantierte Auszahlung'],
    table_rows: [
      ['1', '8', '8', '€1.500 (wöchentliche Raten)'],
      ['2', '8', '16', '€1.500 (wöchentliche Raten)'],
      ['3', '8', '24', '€1.500 (wöchentliche Raten)'],
      ['4', '8', '32', '€1.500 (wöchentliche Raten)'],
      ['Monat 5+', 'Dein Tempo', '32+', '€1.440+ /Monat bei 40% wiederkehrender Provision'],
    ],
    note: 'Bedingungen Anlaufvergütung: maximale Dauer 4 Monate. Die Monatsgarantie gilt, wenn du 8 neue Geschäftskunden in diesem Monat onboardest; die wöchentliche Auszahlung gilt in Wochen, in denen du 2 Geschäftskunden konvertierst. Der Betrag von €1.440+ ist die mindestens erwartete Monatskommission bei einem Portfolio von 32 Kunden. Die tatsächlichen Verdienste hängen von den Modulen ab, die deine Kunden nutzen, und wachsen mit deinem Portfolio. Es gelten allgemeine Geschäftsbedingungen; der vollständige Agentenvertrag wird während des Onboardings mitgeteilt.',
    checks: [
      { strong: 'Kein Deckel auf deinen Verdiensten.', text: '32 Kunden sind die Untergrenze, nicht die Obergrenze. Weiter onboarden und dein wiederkehrendes Einkommen häuft sich an.' },
      { strong: 'Du verkaufst, wir liefern.', text: 'Unser Team kümmert sich um Setup, Design und Support. Deine Kunden sind in guten Händen und dein Portfolio bleibt gesund.' },
      { strong: 'Ein faires Produkt, hinter dem man stehen kann.', text: 'Monatliche Abonnements, kein Lock-in. Restaurants bleiben, weil sie wollen. Und genau deshalb funktioniert wiederkehrende Provision.' },
    ],
  },
  steps: {
    kicker: 'Loslegen',
    heading: 'Von der Anmeldung bis zur ersten Auszahlung in vier Schritten.',
    items: [
      { title: 'Bewerben', text: 'Fülle das Anmeldeformular aus (2 Minuten). Erzähl uns von deinem Netzwerk und deiner Region.' },
      { title: 'Intro & Onboarding', text: 'Ein persönliches Gespräch, Produkttraining und dein Agent-Toolkit: Demo-Umgebung, Preise und Materialien.' },
      { title: 'Mit dem Verkaufen beginnen', text: 'Raus auf die Straße, ins Netzwerk. Wir unterstützen jeden Deal mit schnellem Setup, damit deine Kunden schnell live gehen.' },
      { title: 'Wöchentlich bezahlt werden', text: 'Konvertiere 2 Geschäftskunden in einer Woche und deine Anlaufzahlung kommt in derselben Woche an.' },
    ],
  },
  who: {
    kicker: 'Wen wir suchen',
    heading: 'Hunter mit Gastronomie im Blut.',
    items: [
      { icon: '🤝', title: 'Vernetzt', text: 'Du kennst Restaurantbesitzer, oder du weißt, wie du an sie rankommst. Ein Netzwerk in Quick-Service, Takeout oder Lieferung ist ein Vorsprung.' },
      { icon: '⚡', title: 'Selbstständig', text: 'Du bestimmst dein eigenes Tempo und verwaltest deine eigene Pipeline. Wir geben dir die Tools, das Training und den Support. Du bringst den Antrieb.' },
      { icon: '🌍', title: 'In NL, BE oder DE tätig', text: 'Wir sind in den Niederlanden und Belgien live und starten 2026 in Deutschland. Frühe Agents bekommen als Erstes ihre Region.' },
    ],
  },
  cta: {
    heading: 'Bereit, dein Portfolio aufzubauen?',
    text: 'Bewirb dich in 2 Minuten. Wir melden uns innerhalb von zwei Werktagen, um deinen Einführungsanruf zu planen.',
    button: 'Über das Formular bewerben',
    small: 'Es gelten allgemeine Geschäftsbedingungen. Der vollständige Agentenvertrag und die Provisionskonditionen werden während des Onboardings festgelegt.',
  },
}
